// @flow

import theme from 'config/theme';

export default {
  graphite: theme.colors.deepSpaceSparkle,
  lavender: theme.colors.maximumPurple,
  sea: theme.colors.illuminatingEmerald,
};
